export default "__VITE_ASSET__7f4caed3__"